import React, { useEffect, useState, useRef } from "react";
import FieldRenderer from "./FieldRenderer";
import { Typography, Divider } from "antd";
import { AiFillTags } from "react-icons/ai";
import { Switch } from "antd";
import { gaEvent } from "analytics/analytics";
import * as GA from "../../../constants/analytics";

const { Title } = Typography;
const ICON_STYLE = {
	fontSize: 24,
	padding: 1,
	background: "#f5f5f5",
	borderRadius: 4,
	color: " #9B9F9E",
	marginRight: 10,
};
const ICON_CONTAINER = {
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "start",
};

export default function InternalDetails({ fields,setVendorDetailsButton,showVendorDetails }) {

	const onChangeVendorToggle = () => {
		setVendorDetailsButton(!showVendorDetails);
	};

	const renderVendorToggle = () => {
		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					marginTop: 20,
					marginBottom: 20,
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between",
						marginBottom: 8,
					}}
				>
					<div
						style={{
							fontSize: 14,
							color: "#000000",
							fontWeight: "bold",
						}}
					>
						Is this product sourced from a vendor?
					</div>
					<div>
						<Switch onChange={onChangeVendorToggle} checked={showVendorDetails} onClick={() => {
							gaEvent(GA.EVENT.CLICK, GA.CATEGORY.ADD_PRODUCT, GA.DESCRIPTION.INTERNAL_DETAILS_TOGGLE)
						}} />
					</div>
				</div>

				<div>
					<div style={{ fontSize: 14, color: "#797F7D" }}>
						Click on the toggle if the product is outsourced
					</div>
				</div>
			</div>
		);
	};

	return (
		<div id="vendor" style={{}}>
			<div
				className="ant-divider ant-divider-horizontal"
				role="separator"
			></div>
			{renderVendorToggle()}
			{showVendorDetails && <FieldRenderer fields={fields} />}
			<Divider />
		</div>
	);
}
